import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable } from 'rxjs';
import { PanelResponse } from '../../model';
import { ConverterService } from '../../util';
import { PANEL_RESPONSE_NORMALIZER } from './recommendations-panel-response-normalizer';

@Injectable({
  providedIn: 'root',
})
export class RecommendationsPanelConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  /**
   * Fetch a zone (or a panel) from Apptus eSales.
   *
   * A zone is made up of one or more panels; a panel *is* a zone. We model panels in the backend, so "panelName" sticks.
   *
   * NB: Use a falsy value for productCode or articleCode if you want the one but not the other
   */
  getZone(
    userId: string,
    panelName: string,
    productCode?: string,
    articleCode?: string,
    parameters?: any
  ): Observable<PanelResponse> {
    // NB: the somewhat unexpected underscore naming is to comply with 3rd-party interface-
    // by respecting it here we enable fully dynamic calls and only this spot needs to follow the convention.
    const url = this.occEndpointsService.buildUrl('apptusPanel', {
      urlParams: { userId },
      queryParams: {
        panelName,
        ...(productCode && { product_key: productCode }),
        ...(articleCode && { variant_key: articleCode }),
        ...parameters,
      },
    });

    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.httpClient.get(url, { headers }).pipe(this.converterService.pipeable(PANEL_RESPONSE_NORMALIZER));
  }
}
